import { render, staticRenderFns } from "./CopyrightsBlock.vue?vue&type=template&id=0381e5e0&"
import script from "./CopyrightsBlock.vue?vue&type=script&lang=js&"
export * from "./CopyrightsBlock.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightsBlock.vue?vue&type=style&index=0&id=0381e5e0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports